/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum NotificationType {
  Animation = 'Animation',
  Enquete = 'Enquete',
  AlerteSolde = 'AlerteSolde',
  Paiement = 'Paiement',
  Favoris = 'Favoris',
  Commande = 'Commande',
  EnqueteReponse = 'EnqueteReponse',
  Echange = 'Echange',
  AntiGaspi = 'AntiGaspi',
}
